import { render, staticRenderFns } from "./CgSystemManage.vue?vue&type=template&id=04e108aa&"
import script from "./CgSystemManage.vue?vue&type=script&lang=js&"
export * from "./CgSystemManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports